import { ExodusResources } from './exodus.resource';

export const PrescriptionCategoryUrl = {
    PRESCRIPTIONCATEGORY_GET: ExodusResources.PRESCRIPTIONCATEGORY,
    PRESCRIPTIONCATEGORY_ADD: ExodusResources.PRESCRIPTIONCATEGORY,
    PRESCRIPTIONCATEGORY_UPDATE: ExodusResources.PRESCRIPTIONCATEGORY + '/',
    PRESCRIPTIONCATEGORY_DELETE: ExodusResources.PRESCRIPTIONCATEGORY + '/{id}',
    PRESCRIPTIONCATEGORY_GET_ALL : ExodusResources.PRESCRIPTIONCATEGORY + '/drop-down-list',
    PRESCRIPTIONCATEGORY_DETAIL : ExodusResources.PRESCRIPTIONCATEGORY + '/'    
};


// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/shared/urls/master-data.prescription-category.url.ts